export default __webpack_public_path__ + "static/media/PAE.45c54124.svg";